/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsExchange2 = createReactComponent(
  "arrows-exchange-2",
  "IconArrowsExchange2",
  [
    ["path", { d: "M17 10h-14l4 -4", key: "svg-0" }],
    ["path", { d: "M7 14h14l-4 4", key: "svg-1" }]
  ]
);

export { IconArrowsExchange2 as default };
//# sourceMappingURL=IconArrowsExchange2.js.map
